import { render, staticRenderFns } from "./TopBarLinks.vue?vue&type=template&id=a5fdd8d6&lang=pug&"
import script from "./TopBarLinks.vue?vue&type=script&lang=ts&"
export * from "./TopBarLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports